/* External */
import { memo, useMemo } from 'react';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Styles */
import './SearchResultsSkeletons.scss';

function SearchResultsSkeletons() {
  const row = useMemo(() => (
    <div className="dtv-html5-c-search-results-skeletons__row">
      <Skeleton dark className="dtv-html5-c-search-results-skeletons__card" />
      <Skeleton dark className="dtv-html5-c-search-results-skeletons__card" />
    </div>
  ), []);

  return (
    <div className="dtv-html5-c-search-results-skeletons">
      {row}
      {row}
      {row}
      {row}
    </div>
  );
}

export default memo(SearchResultsSkeletons);
